import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useTrackPageView from '../../hooks/useTrackPageView';
import { PAGE_TYPE } from '../../constants/gaEnums';
import '../../styles/SearchResults.css';
import { searchApi } from '../../api/search';
import PageLayout from '../../components/layout/PageLayout';
import ProgressBar from '../../components/common/ProgressBar';
import { Stack } from '@mui/material';
import SearchResultSection from './SearchResultSection';
import SearchResultHeader from './components/SearchResultHeader';
import InFeedBoxAd from '../../components/ad/InFeedBoxAd';
import { AD_SLOT } from '../../components/ad/GoogleAdSense';
import SidebarLayout from '../../components/layout/SidebarLayout';

const SearchResults = () => {
  useTrackPageView({ pageType: PAGE_TYPE.SEARCH });
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');
  const [searchResults, setSearchResults] = useState({
    artists: { total: 0, items: [] },
    albums: { total: 0, items: [] },
    news: { total: 0, items: [] },
    playlists: { total: 0, items: [] },
    notices: { total: 0, items: [] },
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSearchResults = async () => {
      try {
        setLoading(true);
        const { data } = await searchApi.searchSummary(query);
        setSearchResults(data);
      } catch (err) {
        console.error('Error fetching search results:', err);
      } finally {
        setLoading(false);
      }
    };

    if (query) {
      fetchSearchResults();
    }
  }, [query]);

  return (
    <PageLayout>
      <ProgressBar isLoading={loading}>
        <SearchResultHeader query={query} />
        <SidebarLayout pageType={PAGE_TYPE.SEARCH}>
          <Stack spacing={{ xs: 3.75, md: 5, lg: 6.25 }}>
            <SearchResultSection
              title="Artists"
              count={searchResults.artists.total}
              items={searchResults.artists.items}
            />
            <SearchResultSection
              title="Reviews"
              count={searchResults.albums.total}
              items={searchResults.albums.items}
            />
            <InFeedBoxAd pageType={PAGE_TYPE.SEARCH} adSlot={AD_SLOT.SEARCH_INFEED_2} />
            <SearchResultSection
              title="Mixes"
              count={searchResults.playlists.total}
              items={searchResults.playlists.items}
            />
            <InFeedBoxAd pageType={PAGE_TYPE.SEARCH} />
            <SearchResultSection
              title="Notices"
              count={searchResults.notices.total}
              items={searchResults.notices.items}
            />
          </Stack>
        </SidebarLayout>
      </ProgressBar>
    </PageLayout>
  );
};

export default SearchResults;
